---
fr:
  feature_requests:
    categories:
      api_developer: API/Développeur
      feedback: Feedback
      new_feature: Nouvelle fonctionnalité
    create_request: Créer une demande
    delete: Supprimer
    edit_request: Éditer une demande
    filter_category: Filtrer par catégorie
    filter_status: Filtrer par status
    mail_support: E-mail au support
    model_name: Demande de fonctionnalité
    only_admins_can_delete: Seuls les administrateurs peuvent supprimer une demande de fonctionnalité
    plural: Demande de fonctionnalité
    publish: Créer
    save: Enregistrer
    statuses:
      coming_soon: À venir
      investigating: En évaluation
      launched: Commencé
      new: Nouveau
      not_planned: Pas planifié
